import { render } from "./ColorsPicker.vue?vue&type=template&id=24d83d8f&scoped=true"
import script from "./ColorsPicker.vue?vue&type=script&lang=js"
export * from "./ColorsPicker.vue?vue&type=script&lang=js"

import "./ColorsPicker.vue?vue&type=style&index=0&id=24d83d8f&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-24d83d8f"

export default script